export class WorkerFormValues {

    _dni; // string
    _state; // boolean
    _name; // string
    _lastName; // string
    _agreement; // string
    _outsource; // SelectOption[]
    _contractorId; // number
    _contractorSchema; // SelectOption[]
    _position; // string

    constructor(
        dni,
        state,
        name,
        lastName,
        agreement,
        outsource,
        contractorId,
        contractorSchema,
        position,
    ) {
        this._dni = dni;
        this._state = state;
        this._name = name;
        this._lastName = lastName;
        this._agreement = agreement;
        this._outsource = outsource;
        this._contractorId = contractorId;
        this._contractorSchema = contractorSchema;
        this._position = position;
    }

    static null() {
        return new this(
            '',
            false,
            '',
            '',
            '',
            [],
            -1,
            [],
            '',
        );
    }

    static fromWorker(worker, currentContractorId) {
        const outsource = worker.company();
        const documentation = worker.documentation();
        const mySchema = documentation.mySchema();
        const myDocumentSchema = mySchema.documentSchema();

        return new this(
            worker.dni(),
            worker.isActive(),
            worker.name(),
            worker.lastName(),
            worker.agreement(),
            [
                {
                    label: outsource.description(),
                    value: outsource.id(),
                    item: outsource,
                },
            ],
            currentContractorId,
            myDocumentSchema.id() === -1
                ? []
                : [
                    {
                        label: myDocumentSchema.description(),
                        value: myDocumentSchema.id(),
                        item: myDocumentSchema,
                    },
                ],
            mySchema._position,
        );
    }

    initialValues() {
        return {
            dni: this._dni,
            state: this._state,
            name: this._name,
            lastName: this._lastName,
            job: this._job,
            agreement: this._agreement,
            outsource: this._outsource,
            contractorId: this._contractorId,
            contractorSchema: this._contractorSchema,
            position: this._position,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/WorkerFormValues.js